export const websites = [
  {
    title: "Film Dads",
    subtitle: "Headless WordPress & React Platform",
    description:
      "A high-performance movie review and cinematic analysis publication built with a headless WordPress REST API backend and a responsive React frontend with dynamic routing.",
    image: "./images/project-1.jpg",
    alt: "Film Dads - Movie review blog built with Headless WordPress and React",
    tags: ["React", "Headless WordPress", "REST API", "Tailwind CSS"],
    link: "http://thefilmdads.com",
  },
  {
    title: "The Next Level Consulting",
    subtitle: "Corporate Brand & Strategy Website",
    description:
      "Modern corporate consulting web application engineered for executive advisory services, featuring responsive UX design, smooth state management, and optimized SEO.",
    image: "./images/project-2.jpg",
    alt: "The Next Level Consulting - Business advisory website engineered in React",
    tags: ["React", "JavaScript", "Responsive Design", "UI/UX"],
    link: "http://thenext-level.org",
  },
  {
    title: "OCD New York",
    subtitle: "Non-Profit Advocacy & Resource Portal",
    description:
      "Accessible and community-focused web platform for OCD New York charity organization, designed to connect individuals and families with critical mental health resources and events.",
    image: "./images/project-3.jpg",
    alt: "OCD New York - Non-profit charity resource website built in React",
    tags: ["React", "Web Accessibility", "SCSS", "Client Portal"],
    link: "https://ocdnewyork.org/",
  },
];

export const testimonials = [
  {
    quote:
      "Mark transformed our digital presence with a blazing-fast headless React architecture. His attention to design details, performance, and clear communication made the entire project seamless.",
    name: "Alex Rivera",
    role: "Founder & Creative Director",
    company: "Studio Next NYC",
  },
  {
    quote:
      "Working with Mark was one of the smoothest development experiences we've had. He delivered our non-profit platform ahead of schedule with flawless mobile responsiveness and accessibility.",
    name: "Sarah Jenkins",
    role: "Director of Outreach",
    company: "Community Health Initiative",
  },
];

export const skills = [
  "JavaScript (ES6+)",
  "React & Next.js",
  "TypeScript",
  "Angular",
  "Vue.js",
  "GraphQL & REST APIs",
  "WordPress Headless CMS",
  "Tailwind CSS & SASS",
  "UI/UX Design",
  "Figma & Sketch",
  "Adobe Photoshop & Illustrator",
  "Performance & Web Accessibility",
];

export const socialLinks = [
  {
    name: "GitHub",
    url: "https://github.com/markpolak",
    icon: "github",
  },
  {
    name: "LinkedIn",
    url: "https://linkedin.com/in/markpolak",
    icon: "linkedin",
  },
  {
    name: "Email",
    url: "mailto:contact@marknycweb.com",
    icon: "email",
  },
];

  